import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";

export class CustomSubmitClaim extends SubmitClaim {
    constructor({ appClaimForm, userLanguage, customInitClaim = null, customProcessClaim = null, customLoadMember = null, customDstProcess = null, customAddClaimFile = null, errorHandler }) {
        super(appClaimForm, userLanguage, customInitClaim, customProcessClaim, customLoadMember, customDstProcess, errorHandler);
        this.customAddClaimFile = customAddClaimFile;
    }
    add_claim_file(e) {
        super.add_claim_file(e);
        if (this.customAddClaimFile) {
            this.customAddClaimFile(this.claim);
        }
    }
}
